import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

//import images
import { UploadProps } from "antd";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_BAR_DETAIL_REVIEW_STATUS,
  COLOR_BAR_LIST_OPEN_STATUS,
  COLOR_STICKER_PACKAGE_TYPE,
  LIST_OPTION_BAR_DETAIL_REVIEW_STATUS,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  STICKER_PACKAGE_TYPE_OPTION,
} from "helpers/constans";
import UploadImageSingle from "components/Common/UploadImageSingle";
import { getPackageSticker, postPackageSticker, putPackageSticker } from "store/sticker/thunk";

export interface Props {
  id?: string;
  triggerRefresh?: () => void;
  setLinkImage?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const uploadProps: UploadProps = {
  name: "files",
  accept: "image/png,image/jpeg,image/*",
  beforeUpload: () => false,
  headers: {
    authorization: "authorization-text",
  },
};

const FormEditPackage = ({
  id = "",
  triggerRefresh,
  setLinkImage,
}: Props) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);
      const data = {
        name: values?.name,
        description: values?.description,
        type: values?.type,
        thumbnailUrl: values?.thumbnailUrl,
        status: values?.status
      };
      const response: any = id
        ? await putPackageSticker(id, data)
        : await postPackageSticker(data);
      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(`${t("Name is required")}`),
    // thumbnailUrl: Yup.string().required(`${t("Image is required")}`),
    // files: Yup.array()
    //   .min(1, `${t("This field is required")}`)
    //   .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      status: 1,
      type: 0,
      thumbnailUrl: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (valueDefault: any) => {
    formik.setValues(valueDefault);
  };

  const handleCallPackageDetail = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      const resDetail: any = await getPackageSticker(idItem);
      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
      }
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallPackageDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    document.title = `${t("Update Sticker Package")} - ${t("Sticker Management")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);


  return (
    <React.Fragment>
      <div className="p-3">
        <>
          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="name-bar" className="form-label">
                    {t("Name")} <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="name-bar"
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder={t("Enter your name")}
                    value={formik?.values?.name}
                    onChange={(event: any) =>
                      formik.setFieldValue("name", event?.target?.value)
                    }
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-danger mt-2">{formik.errors.name}</div>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Type")}</Label>

                  <DropdownStatusNew
                    name="type"
                    dataList={STICKER_PACKAGE_TYPE_OPTION || []}
                    placeholder={`${t("Type")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.type}
                    onChangeSelect={(event: any) =>
                      formik.setFieldValue("type", event?.value)
                    }
                    isHasOptionAll={false}
                    optionAll={{ label: t("All Filter"), value: "" }}
                    colors={COLOR_STICKER_PACKAGE_TYPE}
                  />
                  {formik?.touched?.type && formik?.errors?.type ? (
                    <div className="text-danger mt-2">
                      {/* {formik?.errors?.type} */}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Status")}</Label>

                  <DropdownStatusNew
                    name="status"
                    dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                    placeholder={`${t("Open Status")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.status}
                    onChangeSelect={(event: any) =>
                      formik.setFieldValue("status", event?.value)
                    }
                    isHasOptionAll={false}
                    optionAll={{ label: t("All Filter"), value: "" }}
                    colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
                  />

                  {formik?.touched?.status && formik?.errors?.status ? (
                    <div className="text-danger mt-2">
                      {/* {formik?.errors?.status} */}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xxl={12} className="date-picker-wrapper-custom mt-3 mt-md-2">
                <div className="mb-3">
                  <Label className="form-label">{t("Description")}</Label>

                  <textarea
                    className="form-control"
                    name="description"
                    value={formik?.values?.description}
                    placeholder={`${t("Please enter your description")}...`}
                    onChange={(event: any) =>
                      formik.setFieldValue(
                        "description",
                        event?.target?.value || ""
                      )
                    }
                    style={{ height: 80 }}
                  />
                </div>
              </Col>


              <Col xxl={12}>
                <label className="form-label">
                  {t("Thumbnail")}
                </label>

                <UploadImageSingle
                  data={formik.getFieldProps("thumbnailUrl")?.value}
                  setLinkImage={setLinkImage}
                  formik={formik}
                  isMultiple={false}
                  uploadProps={uploadProps}
                  formikNameImage={"thumbnailUrl"}
                />
              </Col>

              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  {(
                    <button type="submit" className="btn btn-primary fs-14">
                      {isLoading ? (
                        <Spinner size="sm" className="me-2"></Spinner>
                      ) : !!id ? (
                        <i className="ri-login-circle-line align-bottom me-2 "></i>
                      ) : (
                        <i className="ri-add-fill align-bottom me-2"></i>
                      )}
                      {id
                        ? t("Button Update")
                        : t("Button Create")}
                    </button>
                  )}
                </div>
              </Col>
            </Row>
          </form>
        </>
      </div>
    </React.Fragment>
  );
};

export default FormEditPackage;
